export default {
    header: {
        products: 'Produtos',
        vg: 'Navegação de Vídeo',
        download: 'descarregar',
        about: 'Sobre Nós'
    },
    pageTitle1: 'Torne sua TV',
    pageTitle2: 'mais inteligente',
    available: 'Pré-venda',
    buy: 'Comprar',
    config: 'Configurar',
    os: {
        title: "Mais formas de jogar, experiência aprimorada",
        intro: "Ecossistema AuroraTV, com AuroraOS desenvolvido com base no Slimbox, realiza otimização profunda da rede do sistema e aceleração abrangente da velocidade, criando uma experiência interativa fluida com arquitetura leve!"
    },
    comment: {
        title: 'Avaliações reais',
        Subtitle: 'Veja o que dizem',
        text: 'Feedback genuíno de quem já comprou, para você escolher com confiança.'
    },
    certificate: {
        title: 'Escolha AURORA',
        text: 'Redefina sua experiência com TV - Sistema Inteligente AURORA'
    },
    aurora: {
        title: 'Ecossistema de Aplicativos AURORA',
        mcplayer: 'O MCPlayer é um player de streaming que oferece transmissões esportivas ao vivo líderes do setor, assinaturas de filmes e TV, suportando eventos em tempo real, vasto conteúdo sob demanda e transmissão de canais de TV. Os canais e conteúdos do MCPlayer podem variar conforme o país ou região.',
        mcstore: 'A McStore é uma loja de aplicativos para Android TV projetada para smart TVs, oferecendo uma grande coleção de aplicativos licenciados, jogos e serviços de vídeo!'
    },
    osIntro: 'Quais são os novos recursos do AURORATV OS em comparação com outros firmwares do mercado?',
    osTitle: 'Mais',
    osSecTitle: 'Funcionalidades Estendidas',
    extended: {
        remote: 'Personalize seus atalhos',
        timezone: 'Resolver Problemas de Fuso Horário',
        clean: 'Limpeza de Memória com Um Toque',
        intro1: 'Personalize as funções dos botões do controle remoto para compatibilidade com vários dispositivos e integração com o sistema AURORA mais recente, permitindo operações rápidas e abertura de aplicativos com um toque.',
        intro2: 'Com apenas um clique, limpe facilmente o cache da TV para melhorar o desempenho, garantir operação mais suave e manter a eficiência ideal da TV.',
        intro3: 'Quando restrições de rede ou falhas no servidor NTP causam problemas de conectividade, troque instantaneamente os servidores NTP para restaurar rapidamente a sincronização do tempo da rede.'
    },
    equipped: {
        title: 'Modelos Compatíveis',
        buy: 'Comprar',
        productParame: 'Especificações',
        tanix: {
            param1: 'CPU: Amlogic S905W2',
            param2: 'Armazenamento: 4+32GB/4+64GB',
            param3: 'Sistema Operacional: Android 11.0'
        },
        x96q: {
            param1: 'CPU: Allwinner H313',
            param2: 'Armazenamento: 2+16GB',
            param3: 'Sistema Operacional: Android 10.0'
        },
        aurora: {
            param1: 'CPU: Amlogic S905W2',
            param2: 'Armazenamento: 4+32GB/4+64GB',
            param3: 'Sistema Operacional: Android 11.0'
        },
        elite: {
            param1: 'CPU: Quad Core ARM Cortex A53',
            param2: 'Armazenamento: 2+16GB',
            param3: 'Sistema Operacional: Android 10.0'
        }
    },
    remote: {
        intro: 'Controle sua TV pelo celular a qualquer hora, em qualquer lugar - uma vida mais fácil e natural na ponta dos seus dedos!',
        download: 'Baixar Agora',
        note: 'Atualmente compatível apenas com',
        andriod: 'celulares Android',
        open_intro: 'Controle aplicativos da TV facilmente pelo celular - abra seus apps favoritos com um toque. Permite ordenação personalizada e fixação de apps mais usados para operação intuitiva.',
        ipt_intro: 'Agora você pode digitar texto na TV sem cliques tediosos - basta digitar no app e enviar direto para sua TV.',
        file_intro: 'Envie arquivos APK diretamente para sua TV para instalar apps - muito mais rápido e conveniente que usar pendrives!',
        ctl_intro: 'O app Aurora Remote permite controlar sua smart TV Android sem precisar de controle físico.',
        fbTitle: 'Pegue seu celular',
        fbSecTitle: 'Abra o app para controlar quando quiser',
        fbIntro: 'Compatível com todos os modelos - basta abrir o app, conectar ao dispositivo e começar a controlar',
        more: 'Mais Funcionalidades'
    },
    application: {
        title: 'Aplicativos exclusivos, todas as informações esportivas na palma da sua mão',
        mcstore: {
            appName: 'MCStore',
            appDesc: 'Oferece centenas de aplicativos seguros para TV, com download e instalação rápidos.'
        },
        mcplayer: {
            appName: 'MCPlayer',
            appDesc: 'Assine e acesse 20.000 canais de TV, 100.000 filmes/séries, incluindo 3.000 canais esportivos.'
        }
    },
    userComment: [{
            content: 'Esta é a segunda vez que compro esta TV box, funciona normalmente, conexão à internet rápida e simples, estou satisfeito até agora, sem reclamações!'
        },
        {
            content: 'Excelente! Funciona perfeitamente logo após desembalar! Tem canais de TV e filmes! Tudo funciona sem travamentos ou falhas'
        },
        {
            content: 'Qualidade excelente, tudo funciona sem problemas. Gosto muito, os aplicativos instalam sem dificuldade'
        },
        {
            content: 'TV box excelente, muito melhor do que a que eu usava antes, imagem de qualidade, funciona rapidamente. Configuração sem problemas'
        },
        {
            content: 'Estou satisfeito com a compra, os clientes também. Instalo o que cada um precisa, refiro-me aos firmwares. No geral as pessoas estão satisfeitas e eu não saio no prejuízo'
        },
        {
            content: 'Eu sabia o que estava comprando - esta é atualmente a melhor TV box em relação custo-benefício! Posso recomendar a compra com confiança!'
        }
    ],
    feature: {
        specification: 'especificação',
        product: 'produtos',
        x96q: {
            f: "Núcleo de performance, resposta instantânea",
            s: "Compatibilidade total com dispositivos"
        },
        aurora: {
            f: "Arquitetura quad-core A35",
            s: "Wi-Fi 5 dual-band"
        },
        tanix: {
            f: "Firmware personalizado Slimbox+",
            s: "Sistema de resfriamento silencioso"
        }
    },
    videoGuidece: 'Perguntas e respostas operacionais',
    videoTitle: 'Vídeo tutorial',
    videoIntroduction1: 'Vídeo de instalação do Tanix W2',
    videoIntroduction2: 'Vídeo tutorial do aplicativo MCPlayer',
    videoIntroduction3: 'Tutorial de Emparelhamento de Controle Remoto Bluetooth',
    dowmloadRemote: {
        mainDesc: 'Compatível com todas as TV boxes Aurora com sistema SlimBOX+. Use o aplicativo Aurora Remote para controlar facilmente sua TV pelo smartphone! Basta conectar sua Smart TV e o Aurora Remote na mesma rede WiFi ou emparelhar via Bluetooth para ligar/desligar a TV, abrir aplicativos com um toque, ajustar volume e instalar aplicativos!',
        dowmload: 'Baixar Aplicativo',
        text1: 'Atualmente só suporta',
        text2: 'Celulares Android',
        text3: 'versão',
        title: 'Controle Remoto AURORA para TV',
        secondary_title: 'Controle sua TV com facilidade e descubra experiências mais inteligentes',
        quick_title: 'Inicialização',
        quick_title_sec: 'Rápida',
        quick_open_txt: 'O sistema escaneia automaticamente todos os aplicativos instalados na TV enquanto permite ordenação personalizada. Através de arrastar e soltar, você pode fixar seus aplicativos favoritos no topo, criando atalhos de acesso rápido para abrir com um toque.',
        file_title: 'Transferência',
        file_secondary_title: 'de Arquivos',
        file_txt: 'Sem necessidade de USB! Use o recurso de upload de arquivos do Aurora Remote para transferir APKs para sua TV box e instalar aplicativos.',
        media_title: 'Touchpad',
        media_secondary_title: 'Responsivo',
        media_txt: 'Navegue usando teclas direcionais ou deslizando no touchpad, como um controle remoto físico!',
        search_title: 'Entrada e Busca',
        search_secondary_title: 'Rápida',
        search_txt: 'Suporte a entrada rápida de texto e busca para operação mais eficiente da TV.'
    },
    dowmloadMcstore: {
        mainDesc: 'Plataforma de loja de aplicativos própria da AURORA. Oferecemos mais de cem aplicativos para TV confiáveis e seguros, para que você possa baixar e usar com facilidade e rapidez.',
        dowmload: 'Baixar aplicativo',
        text1: 'Este aplicativo é compatível apenas com',
        text2: 'Andriod TV'
    },
    about: {
        headHL: 'Olá!',
        headSub: 'Somos a AURORA',
        outTitle1: 'O que é a AURORA?',
        outIntro1: 'A AURORA é uma empresa de TI e um laboratório criativo, equipado com instalações de produção avançadas, uma comunidade vibrante, criatividade dinâmica e uma cultura onde todos se sentem valorizados. Desde 2024, nos dedicamos a criar tecnologia, dispositivos inteligentes e serviços convenientes para as pessoas. Garantia de Qualidade',
        outTitle2: 'Garantia de Qualidade',
        outIntro2: 'Todo trabalho começa com pesquisa. Com base nisso, realizamos desenvolvimento conceitual multidimensional, iteração de protótipos, construção de arquitetura de hardware e validação de design. Durante o processo, integramos recursos de especialistas líderes do setor, estabelecemos colaboração com instituições de pesquisa e conduzimos testes sistemáticos com equipamentos profissionais avançados. As necessidades futuras dos usuários guiam todo o ciclo de desenvolvimento de nossos dispositivos, serviços e tecnologias.',
        outTitle3: 'Garantia de Serviço',
        outIntro3: 'Todos os decodificadores AURORA são produtos originais. Da pesquisa e desenvolvimento à produção e vendas, eles passam por rigorosos controles de qualidade, com cada unidade inspecionada em múltiplas etapas para garantir desempenho estável e alta qualidade, proporcionando uma experiência confiável e superior.',
        outTitle4: 'Investidores',
        outIntro4Part1: 'Para dúvidas relacionadas a investimentos, envie um e-mail para ',
        outIntro4Part2: ' ou entre em contato via Telegram/WhatsApp.',
        outTitle5: 'Clientes Individuais',
        outIntro5Part1: 'Para questões gerais, como pedidos individuais ou em massa, preços, logística, pagamento, entrega e política de devolução, visite a ',
        outIntro5Part2: 'loja oficial da OZON',
        outIntro5Part3: ' para assistência.',
        contactHL: 'Cooperação Comercial',
        contactSub: 'Contato'
    },
    footer: {
        serverTitle: 'Horário de Atendimento:',
        serverTime: 'Segunda a sexta-feira, das 9:00 às 12:00 e das 14:00 às 19:00, exceto feriados oficiais'
    }
}